import { render, staticRenderFns } from "./designChange.vue?vue&type=template&id=198ebae8&scoped=true"
import script from "./designChange.vue?vue&type=script&lang=js"
export * from "./designChange.vue?vue&type=script&lang=js"
import style0 from "./designChange.vue?vue&type=style&index=0&id=198ebae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ebae8",
  null
  
)

export default component.exports